import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap";
import * as moment from "moment";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "./TableContainer";
//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import {
  getOrders as onGetOrders,
  cancelOrder as onCancelOrder,
  getProductById as onGetProductById,
} from "../../slices/thunks";

import "react-toastify/dist/ReactToastify.css";

import { createSelector } from "reselect";
import OrderDetail from "./OrderDetail";
import Loader from "../../Components/Common/Loader";
import CancelModal from "./CancelModal";
import { orderStatus } from "../../Components/constants/layout";
import ProductDetail from "../Products/ProductDetail";

const DebouncedInput = ({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [debounce, onChange, value]);

  return (
    <input
      {...props}
      value={value}
      id="search-bar-0"
      className="form-control search"
      onChange={(e) => setValue(e.target.value)}
    />
  );
};

const CustomerOrders = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [showProductModal, setShowProductModal] = useState(false);

  const dispatch = useDispatch();

  const selectOrderData = createSelector(
    (state) => state.Orders,
    (orders) => orders.orders,
    (pagination) => pagination
  );
  // Inside your component
  const { orders, pagination } = useSelector(selectOrderData);
  const product = useSelector((state) => state.Products?.product);
  // Inside your component

  const [orderList, setOrderList] = useState([]);
  // const [order, setOrder] = useState([]);
  const [showCancelOrder, setShowCancelOrder] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [searchText, setSearchText] = useState(null);

  useEffect(() => {
    orders && setOrderList(orders);
    setIsLoading(false);
  }, [orders]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setIsLoading(true);
      setActiveTab(tab);
      //let filteredOrders = orders;
      const data = {
        page: 0,
        total_rows: pagination?.pageSize,
        searchText: searchText,
        sort_by: "ord_id",
        status: null,
      };

      switch (type) {
        case "all":
          data.status = null;
          break;
        case "Ordered":
          data.status = 4;
          break;
        case "Pending":
          data.status = 0;
          break;
        case "Cancelled":
          data.status = 5;
          break;
        default:
          data.status = null;
          break;
      }
      dispatch(onGetOrders(data));
    }
  };

  const getOrders = (page, pageSize) => {
    setIsLoading(true);
    const data = {
      page: page ? page : 0,
      total_rows: pageSize ? pageSize : pagination ? pagination?.pageSize : 50,
      searchText: searchText,
      sort_by: "ord_id",
      status: null,
    };
    dispatch(onGetOrders(data));
  };

  useEffect(() => {
    if (searchText != null) {
      getOrders();
    }
  }, [searchText]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      // setOrder(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleOrderClicks = () => {
    //setOrder("");
    //setIsEdit(false);
    toggle();
  };

  const handleOrderClick = (order) => {
    setSelectedOrder(order);
    setModal(true);
  };
  
  const handleProductClick = (row) => {
    const proId = row?.ord_pro_id;
    if (proId) {
      setShowProductModal(true);
      dispatch(onGetProductById({ pro_id: proId }));
    }
  };
  /*
  useEffect(() => {
    selectedOrder && setModal(true);
  }, [selectedOrder]);
*/
  // Node API
  // useEffect(() => {
  //   if (isOrderCreated) {
  //     setOrder(null);
  //     dispatch(onGetOrders());
  //   }
  // }, [
  //   dispatch,
  //   isOrderCreated,
  // ]);

  const onClickCancelOrder = (order) => {
    setSelectedOrder(order);
    setShowCancelOrder(true);
  };

  const cancelOrder = (data) => {
    console.log("cancel order", data);
    dispatch(onCancelOrder(data));
    setShowCancelOrder(false);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        header: "Order #",
        accessorKey: "ord_id",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <Link
              className="fw-medium link-primary"
              onClick={() => handleOrderClick(cell.row.original)}
            >
              {cell.getValue()}
            </Link>
          );
        },
      },
      /*
      {
        header: "Cartzy #",
        accessorKey: "ord_bc10_order_id",
        enableColumnFilter: false,
        cell: (cell) => {
          return cell.getValue() == 0 ? "N/A" : cell.getValue();
        },
      },
      */
      {
        header: "Product",
        accessorKey: "productName",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
              <Link
                className="fw-medium link-primary"
                onClick={() => handleProductClick(cell.row.original)}
              >
                {cell.getValue()}
              </Link>
            </div>
          );
        },
      },
      {
        header: "Product codes",
        accessorKey: "productUPC",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <span>
              {cell.getValue() ? cell.getValue() : "No UPC Code"}
              {cell.row.original.productASIN && (
                <span> / {cell.row.original.productASIN}</span>
              )}
            </span>
          );
        },
      },
      {
        header: "Quantity",
        accessorKey: "ord_quantity",
        enableColumnFilter: false,
      },
      {
        header: "Price",
        accessorKey: "ord_totalPrice",
        enableColumnFilter: false,
        cell: (cell) => (
          <>
            <span className="fw-semibold">
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(cell.getValue())}
            </span>
          </>
        ),
      },
      {
        header: "Order Date",
        accessorKey: "ord_dateCreated",
        enableColumnFilter: false,
        cell: (cell) => (
          <>
            {moment(cell.getValue()).format("MM/DD/YYYY")}
            <br />
            <small className="text-muted">
              {"     "}
              {moment(cell.getValue()).format("hh:mm A")}
            </small>
          </>
        ),
      },
      {
        header: "Status",
        accessorKey: "ord_status",
        enableColumnFilter: false,
        cell: (cell) => {
          if (cell.row.original.ord_cancellationReason)
            return (
              <span
                style={{ width: "100px" }}
                className="badge text-uppercase text-dark bg-danger "
              >
                Cancelled
              </span>
            );
          switch (cell.getValue()) {
            case orderStatus.STATUS_ACTIVE:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-dark text-uppercase bg-warning"
                >
                  Pending
                </span>
              );
            case orderStatus.STATUS_ORDERED:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-dark text-uppercase bg-info"
                >
                  Ordered
                </span>
              );
            case orderStatus.STATUS_CANCELLED:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-dark text-uppercase bg-danger "
                >
                  Cancelled
                </span>
              );
            case orderStatus.STATUS_SHIPPED:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-dark text-uppercase bg-success"
                >
                  SHIPPED
                </span>
              );
            case 12:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-dark text-uppercase bg-danger"
                >
                  Paiment failed
                </span>
              );
            default:
              return (
                <span
                  style={{ width: "100px" }}
                  className="badge text-dark text-uppercase bg-warning  text-dark"
                >
                  {" "}
                  {cell.getValue()}{" "}
                </span>
              );
          }
        },
      },

      {
        header: "Action",
        cell: (cellProps) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item">
                <Link
                  className="text-primary d-inline-block"
                  onClick={() => handleOrderClick(cellProps.row.original)}
                >
                  <i className="ri-eye-fill fs-16"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [handleOrderClick]
  );

  document.title = "Orders | Buyers Club";
  return (
    <div className="page-content">
      <OrderDetail
        show={modal}
        onCloseClick={() => setModal(false)}
        orders={selectedOrder}
        onCancelClick={(orders) => onClickCancelOrder(orders)}
      />
      <CancelModal
        show={showCancelOrder}
        onCancelClick={(data) => cancelOrder(data)}
        onCloseClick={() => setShowCancelOrder(false)}
        order={selectedOrder}
      />
      <ProductDetail
        show={showProductModal}
        product={product}
        onClose={() => setShowProductModal(false)}
      />
      <Container fluid>
        <BreadCrumb title="Orders List" pageTitle="Orders" />
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="border-0">
                <Row className="align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Order History</h5>
                  </div>
                </Row>
              </CardHeader>

              <CardBody className="pt-0">
                <div>
                  <div className="card-header border-0">
                    <div className="row align-items-center">
                      <Nav
                        className="nav-tabs-custom card-header-tabs border-bottom-0"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            className={classnames(
                              {
                                active: activeTab === "1",
                              },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("1", "all");
                            }}
                            href="#"
                          >
                            <i className="ri-store-2-fill me-1 align-bottom"></i>{" "}
                            All Orders
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination?.total}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "2" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("2", "Ordered");
                            }}
                            href="#"
                          >
                            Ordered
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination?.totalOrdered}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "3" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("3", "Pending");
                            }}
                            href="#"
                          >
                            Pending
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination?.totalPendingOrders}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "4" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("4", "Cancelled");
                            }}
                            href="#"
                          >
                            Cancelled
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination?.totalCancelled}
                            </span>
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>
                  </div>
                  <Row className="mb-3">
                    <CardBody className="border border-dashed border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <DebouncedInput
                                value={searchText ?? ""}
                                onChange={(value) => setSearchText(value)}
                                placeholder="Search orders"
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="card-body pt-0">
                    {isLoading ? (
                      <Loader />
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={orderList || []}
                        customPageSize={50}
                        divClass="table-responsive table-card mb-1"
                        tableClass="mb-0 align-middle table-borderless"
                        theadClass="table-light text-dark text-uppercase"
                        handleOrderClick={handleOrderClicks}
                        SearchPlaceholder="Search orders..."
                        pagination={pagination}
                        manualPagination={true}
                        isLoading={isLoading}
                        onPreviousPage={() => {
                          getOrders(pagination.currentPage - 1);
                        }}
                        onNextPage={() => {
                          getOrders(pagination.currentPage + 1);
                        }}
                        onGetPage={(page, pageSize) => {
                          getOrders(page, pageSize);
                        }}
                      />
                    )}
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CustomerOrders;
